const saveWorkflow = {
	headline: 'Save & Share in My QIAGEN',
	title: 'Log in or create a new account to',
	list: [
		'Securely store all your experiments',
		'Access your experiments anywhere, anytime',
		'Collaborate with colleagues by sharing experiments',
	],
}
const requestQuote = {
	headline: 'Contact Sales',
	title: 'Log in or create a new account to',
	list: [
		'Request a quote or demo',
		'Have an individual Sales Representative assigned to you',
		'View account-specific pricing & offers',
	],
}

const requestGenomic = {
  headline: 'Contact Genomic Services',
  title: 'Log in or create a new account to',
  list: [
    'Discuss your research with our experts',
    'Have an individual Genomic Specialist assigned to you',
    'Select experiment steps for us to process',
  ],
}

const shareWorkflow = {
	headline: 'Share your experiment',
	title: 'Log in or create a new account to',
  list: [
    'Collaborate with your colleagues',
    'Share project notes with your team and supervisor',
    'Supercharge your teamwork'
  ],
}

const activateLabDocumentation = {
	headline: 'Activate Lab Documentation',
	title: 'Log in or create a new account to',
  list: [
    'Create your lab documentation',
    'Share project notes with your team and supervisor',
    'Supercharge your teamwork'
  ],
}

const preLoginData = {
	saveWorkflow,
	requestQuote,
  requestGenomic,
	shareWorkflow,
	activateLabDocumentation
};

export { preLoginData };
